import { Agent, AgentAccessLevel } from "~/services/agents";

// Deleting an agent maps to the owner-only `can_delete` grant; editors,
// USER-level grants, and SYSTEM agents (null access_level) never confer it.
// Distinct from editing (`can_edit`), which editors also hold.
export const useCanDeleteAgent = (agent: Agent | undefined): boolean =>
  !!agent && agent.access_level === AgentAccessLevel.OWNER;
